// eslint-disable-next-line no-unused-vars
import Flatpickr from 'flatpickr';
import {
  dateFromIso,
  formatDateToIsoDateString,
} from './lib/toujou-datepicker-helper';
import { ToujouDatepicker } from './toujou-datepicker';

class ToujouDaterangepicker extends ToujouDatepicker {
  static get is() {
    return 'toujou-daterangepicker';
  }

  constructor() {
    super();
    this.mode = 'range';
    this._onDateRangeChange = this._onDateRangeChange.bind(this);
  }

  createRenderRoot() {
    return this;
  }

  /**
   * @return {HTMLInputElement}
   */
  get dateFromInput() {
    return this.querySelector('.date-range--from');
  }

  /**
   * @return {HTMLInputElement}
   */
  get dateUntilInput() {
    return this.querySelector('.date-range--until');
  }

  /**
   * @return {HTMLInputElement}
   */
  get dateFacedInput() {
    return this.querySelector('.date-range--facade');
  }

  /**
   * @return {Flatpickr}
   */
  get flatpickr() {
    if (this.dateFacedInput == null) {
      throw new Error('Facade is missing');
    }

    if (Object.prototype.hasOwnProperty.call(this.dateFacedInput, '_flatpickr') === false) {
      throw new Error('Flatpickr is not initialized');
    }

    return this.dateFacedInput._flatpickr;
  }

  connectedCallback() {
    super.connectedCallback();
    this._initDatepicker(this.dateFacedInput);
    this.dateFacedInput.addEventListener('change', this._onDateRangeChange);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.dateFacedInput.removeEventListener('change', this._onDateRangeChange);
  }

  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);

    const dates = [];

    const dateFromIsoString = this.dateFromInput.value;
    const dateUntilIsoString = this.dateUntilInput.value;

    if (dateFromIsoString && dateFromIsoString !== '') {
      dates.push(dateFromIso(dateFromIsoString));
    }
    if (dateUntilIsoString && dateUntilIsoString !== '') {
      dates.push(dateFromIso(dateUntilIsoString));
    }

    this.flatpickr.setDate(dates);
  }

  _onDateRangeChange() {
    const { selectedDates } = this.flatpickr;

    this.dateFromInput.value = formatDateToIsoDateString(selectedDates[0]);
    this.dateUntilInput.value = formatDateToIsoDateString(selectedDates[selectedDates.length - 1]);
  }
}

customElements.define(ToujouDaterangepicker.is, ToujouDaterangepicker);
